type ComputeLastPageType = (totalItems: number, itemsPerPage?: number) => number;

const computeLastPage: ComputeLastPageType = (totalItems, itemsPerPage = 30) => Math.ceil(totalItems / itemsPerPage);

export default computeLastPage;
